<template>
  <div class="bills">
    <BillList
      ref="BillList"
      :bills="bills"
      :denomination="denomination"
      :series="series"
      :feature="feature"
      @bill="billChanged"
      @feature="featureChanged"
    />
  </div>
</template>

<script>
import BillList from '@/components/bill-list/BillList.vue';
import bills from '@/data/bills.json';

export default {
  components: { BillList },
  data() {
    return {
      bills,
    };
  },
  computed: {
    denomination() {
      return parseInt(this.$route.params.denomination, 10);
    },
    series() {
      return this.$route.params.series;
    },
    feature() {
      return this.$route.params.feature;
    },
  },
  methods: {
    billChanged(denomination, series) {
      const { feature } = this;
      console.log('billChanged', feature, denomination, series);

      this.$router.push({
        name: 'bills',
        params: { denomination, series },
      });
    },
    featureChanged(feature) {
      const { denomination, series } = this;
      console.log('featureChanged', feature, denomination, series);

      if (feature) {
        // Feature detail
        this.$router.push({
          name: 'features',
          params: { denomination, series, feature },
        });
      } else {
        // Bill list
        this.$router.push({
          name: 'bills',
          params: { denomination, series },
        });
      }
    },
  },
};

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/bills.vue